import { render, staticRenderFns } from "./UserProfileFieldSources.vue?vue&type=template&id=122c1ea4&scoped=true&"
import script from "./UserProfileFieldSources.vue?vue&type=script&lang=js&"
export * from "./UserProfileFieldSources.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileFieldSources.vue?vue&type=style&index=0&id=122c1ea4&prod&lang=scss&scoped=true&"
import style1 from "./UserProfileFieldSources.vue?vue&type=style&index=1&id=122c1ea4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122c1ea4",
  null
  
)

export default component.exports